import { LoadingSpinnerIcon } from '#app/__generated__/components/Icons/LoadingSpinner.js';
import { animated } from '#app/components/Primitives/Animated.js';
import { isThemeColor } from '#app/theme/index.js';
import { css, styled } from 'styled-components';

type LoaderProps = {
  readonly color?: string;
  readonly size?: number;
};

const LoaderContainer = styled(animated.div)`
  display: flex;
`;

const StyledLoadingSpinner = styled(LoadingSpinnerIcon)<{ color: string }>`
  ${({ color, theme }) => css`
    & > path {
      stroke: ${isThemeColor(color) ? theme.colors[color] : color};
    }
  `}
`;

export const Loader = ({
  color = 'brandWhite',
  size = 28,
  ...props
}: LoaderProps) => {
  return (
    <LoaderContainer
      animate={{ rotate: 360 }}
      transition={{ duration: 1, repeat: Number.POSITIVE_INFINITY }}
    >
      <StyledLoadingSpinner
        color={color}
        size={size}
        {...props}
      />
    </LoaderContainer>
  );
};
